import { useState } from 'react';
import { postAPI } from '../../api';

// Mismos límites que la API (/upload): JPG o PNG de hasta 1 MB.
export const MAX_BYTES = 1000000;
const TIPOS = ['image/jpeg', 'image/png'];
// Algo más que el límite de la API (30 s) para recibir su respuesta 504 antes de cortar aquí.
const TIMEOUT_MS = 45000;

export async function subirImagen(file) {
  const formData = new FormData();
  formData.append('image', file);
  return postAPI('upload', formData, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: TIMEOUT_MS });
}

export function validarImagen(file) {
  if (!file) return 'Selecciona una imagen antes de subirla';
  if (!TIPOS.includes(file.type)) return 'Solo se admiten imágenes JPG o PNG';
  if (file.size > MAX_BYTES) return 'La imagen supera el máximo de 1 MB';
  return '';
}

// Subida del cartel o la foto, compartida por los formularios de obras, cursos y equipo.
// Siempre termina en la URL subida o en un mensaje de error: nunca se queda en «Subiendo imagen...».
export default function CartelUpload({ value, onChange }) {
  const [file, setFile] = useState();
  const [estado, setEstado] = useState('');
  const [error, setError] = useState(false);
  const [subiendo, setSubiendo] = useState(false);

  const submit = async event => {
    event.preventDefault();
    const invalida = validarImagen(file);
    if (invalida) { setError(true); setEstado(invalida); return; }
    setError(false);
    setEstado('Subiendo imagen...');
    setSubiendo(true);
    try {
      onChange(await subirImagen(file));
      setEstado('Imagen subida');
    } catch (e) {
      setError(true);
      setEstado(`No se pudo subir la imagen: ${e.message}`);
    } finally {
      setSubiendo(false);
    }
  };

  return (
    <div className="upload-image">
      <div>
        <input onChange={e => { setFile(e.target.files[0]); setEstado(''); setError(false); }} type="file" accept="image/jpeg,image/png"></input>
        <button id="btn-image" type="button" onClick={submit} disabled={subiendo}>Subir imagen</button>
      </div>
      {value && <img alt="Vista previa de la imagen" src={value} width="500rem"></img>}
      <span role="status" className={error ? 'form-error' : undefined}>{estado || (!value && 'Sin imagen')}</span>
    </div>
  );
}
